// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_ti-0";